import React, { Component } from 'react';

import './../../../selections/timeSelection/components/timeSelect/cliente.css';

import MapSelect from './../components/mapSelect'


//Actualizacion develop
class MapSelection extends Component {
  constructor(props) {
    super(props);
    this.setComune = this.setComune.bind(this);
    this.setNeighborhood = this.setNeighborhood.bind(this);
    this.state = {
      comunes: [],
      neigborhoods: []
    }
  }

  Splice = (vec, data) => {
    var resp = [];
    for (let i = 0; i < vec.length; i++) {
      if (vec[i] !== data) {
        resp.push(vec[i])
      }
    }
    return resp;
  }

  setComune(e, a) {
    // var array = this.state.comunes;
    // if (!array.includes(e)) {
    //     array.push(e);
    //     this.setState({
    //         comunes: array
    //     })
    // }
    // this.props.dataMapComunes(this.state.comunes);
    this.props.dataMapComunes(e, a);
  }
  setNeighborhood(e, a) {
    // var array = this.state.neigborhoods;
    // if (!array.includes(e)) {
    //     array.push(e);
    //     this.setState({
    //         neigborhoods: array
    //     })
    // }
    // this.props.dataMapNeigborhoods(this.state.neigborhoods);
    this.props.dataMapNeigborhoods(e, a);
  }
  setCuadrante = (e) => {
    this.props.setCuadrante([e]);
  }

  componentDidUpdate(prevProps, prevState) {
    try {
      if (prevProps.locationObject.barrio !== this.props.locationObject.barrio) {
        this.setState({
          neigborhoods: this.props.locationObject.barrio
        })
      }
      if (prevProps.locationObject.comuna !== this.props.locationObject.comuna) {
        this.setState({
          comunes: this.props.locationObject.comuna
        })
      }

    } catch (error) {

    }
  }




  render() {
    return (
      <MapSelect
        onTipeSearch={this.searchComune}
        onComunaSelect={this.setComune}
        onNeigborhoodsSelect={this.setNeighborhood}
        onCuadranteSelect={this.setCuadrante}
        data={this.props.data}
        searchData={this.props.searchData}
        dataList={this.props.dataList}
        currentShapes={this.state}
        fromMap={this.props.fromMap}
        sendPolygon={this.props.sendPolygon}
      />
    );
  }
}

export default MapSelection;